// Angular
import { Component, OnInit, ChangeDetectionStrategy, OnDestroy, ChangeDetectorRef, Inject, ViewRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// Material
import { MatPaginator, MatSort, MatDialog, MatTableDataSource, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
// RxJS
import { Observable, BehaviorSubject, Subscription, ReplaySubject } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
// NGRX
// Service
import { SubheaderService } from '../../../../../core/_base/layout';
import { LayoutUtilsService, MessageType } from '../../../../../core/_base/crud';
import { NhaCungCapService } from '../nha-cung-cap-service/nha-cung-cap.service';
//Models
import { NhaCungCapModel } from '../nha-cung-cap-model/nha-cung-cap.model';
import objectPath from 'object-path';
import { CommonConFig } from 'app/views/pages/nfc/dung-chung/__model/common_config.model';
import { DungChungService } from '../../dung-chung/__services/dung-chung.service';
@Component({
	selector: 'kt-nha-cung-cap-edit',
	templateUrl: './nha-cung-cap-edit.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NhaCungCapEditComponent implements OnInit, OnDestroy {
	/*Config Form */
	CONFIG: CommonConFig;
	// Public properties
	NhaCungCap: NhaCungCapModel;
	NhaCungCapForm: FormGroup;
	hasFormErrors: boolean = false;
	loadingSubject = new BehaviorSubject<boolean>(true);
	loading$: Observable<boolean>;
	viewLoading: boolean = false;
	isChange: boolean = false;
	fixedPoint = 2;
	listId_LoaiNCC: any[] = [];
	listId_Tinh: any[] = [];
	// selectId_Tinh : string;
	validEmail: boolean = true
	selectId_Tinh: string[] = [];
	filteredId_Tinh: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	Id_TinhFilterCtrl: string = '';
	haveElementId_Tinh: boolean = false;
	selectId_LoaiNCC: string = '';
	filteredId_LoaiNCC: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	Id_LoaiNCCFilterCtrl: string = '';
	haveElementId_LoaiNCC: boolean = false;
	selectedId_LoaiNCC:string='';
	listId_NhomNCC: any[] = [];
	selectId_NhomNCC: string = '';
	filteredId_NhomNCC: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	Id_NhomNCCFilterCtrl: string = '';
	haveElementId_NhomNCC: boolean = false;
	selectedId_NhomNCC:string='';
	optionNhomNCC: any[] = [
		{
			value: '1',
			name: 'Có hệ thống ATTP'
		},
		{
			value: '2',
			name: 'Không có hệ thống ATTP'
		}
	]
	private componentSubscriptions: Subscription;
	category_path = "NCC";
	constructor(
		public dialogRef: MatDialogRef<NhaCungCapEditComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private NhaCungCapFB: FormBuilder,
		public dialog: MatDialog,
		private layoutUtilsService: LayoutUtilsService,
		private changeDetectorRefs: ChangeDetectorRef,
		private nhacungcapsService: NhaCungCapService,
		private dungChungService : DungChungService
		) { }
	/**
	 * On init
	 */
	ngOnInit() {
		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();
		/*Handel keydown event in dialog*/
		this.dialogRef.keydownEvents().subscribe(event => {
			// 
			if (event.key == this.CONFIG.BUTTON_FORM.BACK.KeyCombine.description) {
				this.back();
			}
			else if (event.altKey && event.keyCode == this.CONFIG.BUTTON_FORM.SAVE_AND_CLOSE.KeyCombine.keycode) {
				this.onSubmit(1);
			}
			else if (event.altKey && event.keyCode == this.CONFIG.BUTTON_FORM.SAVE_AND_NEW.KeyCombine.keycode) {
				this.onSubmit(2);
			}
			this.changeDetectView();
		});
		this.viewLoading = false;
		this.NhaCungCap = this.data.NhaCungCap;
		this.createForm();
		this.ListId_LoaiNCC();
		this.ListId_Tinh();
		this.ListNhomNCC();
	}
	/**
	 * On destroy
	 */
	ngOnDestroy() {
		if (this.componentSubscriptions) {
			this.componentSubscriptions.unsubscribe();
		}
	}
	/**
	 * Create form
	 */
	createForm() {
		this.NhaCungCapForm = this.NhaCungCapFB.group({
			maNCC: [(this.NhaCungCap.MaNCC == null || this.NhaCungCap.MaNCC == '') ? '' : this.NhaCungCap.MaNCC, Validators.required],
			tenNCC: [(this.NhaCungCap.TenNCC == null || this.NhaCungCap.TenNCC == '') ? '' : this.NhaCungCap.TenNCC, Validators.required],
			Id_LoaiNCC: [(this.NhaCungCap.Id_LoaiNCC == null||this.NhaCungCap.Id_LoaiNCC == 0) ? this.selectedId_LoaiNCC : '' + this.NhaCungCap.Id_LoaiNCC, Validators.required],
			Id_Tinh: [(this.NhaCungCap.Id_Tinh == null||this.NhaCungCap.Id_Tinh == 0) ? '' : '' + this.NhaCungCap.Id_Tinh, Validators.required],
			Id_NCC: [(this.NhaCungCap.nhomncc == null||this.NhaCungCap.nhomncc == '') ? this.selectedId_NhomNCC : '' + this.NhaCungCap.nhomncc],
			diaChi: [(this.NhaCungCap.DiaChi == null) ? '' : this.NhaCungCap.DiaChi],
			dienThoai: [(this.NhaCungCap.DienThoai == null) ? '' : this.NhaCungCap.DienThoai],
			fax: [(this.NhaCungCap.Fax == null) ? '' : this.NhaCungCap.Fax],
			mST: [(this.NhaCungCap.MST == null) ? '' : this.NhaCungCap.MST],
			soTK1: [(this.NhaCungCap.SoTK1 == null) ? '' : this.NhaCungCap.SoTK1],
			nganHang1: [(this.NhaCungCap.NganHang1 == null) ? '' : this.NhaCungCap.NganHang1],
			soTK2: [(this.NhaCungCap.SoTK2 == null) ? '' : this.NhaCungCap.SoTK2],
			nganHang2: [(this.NhaCungCap.NganHang2 == null) ? '' : this.NhaCungCap.NganHang2],
			email: [(this.NhaCungCap.Email == null) ? '' : this.NhaCungCap.Email, Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)],
			soNgayThanhToan: [(this.NhaCungCap.SoNgayThanhToan == null || this.NhaCungCap.SoNgayThanhToan == '') ? null : this.NhaCungCap.SoNgayThanhToan, Validators.compose([Validators.min(0), Validators.pattern(/^([0-9]{0,10})$/)])],
			nguoiLienHe: [(this.NhaCungCap.NguoiLienHe == null) ? '' : this.NhaCungCap.NguoiLienHe],
			soDTNguoiLienHe: [(this.NhaCungCap.SoDT_NguoiLienHe == null) ? '' : this.NhaCungCap.SoDT_NguoiLienHe],
			ghiChu: [(this.NhaCungCap.GhiChu == null) ? '' : this.NhaCungCap.GhiChu],
			xepLoai: [(this.NhaCungCap.XepLoai == null) ? '' : this.NhaCungCap.XepLoai],
			nhomncc: [(this.NhaCungCap.nhomncc == null) ? '' : this.NhaCungCap.nhomncc],
			LoaiHinhKD: [(this.NhaCungCap.LoaiHinhKD == null) ? '' : this.NhaCungCap.LoaiHinhKD],
			DieuKienThanhToan: [(this.NhaCungCap.DieuKienThanhToan == null) ? '' : this.NhaCungCap.DieuKienThanhToan],
		});
		//this.NhaCungCapForm.controls['maNCC'].disable();
		this.changeDetectorRefs.detectChanges();
	}
	/**
	 * Returns page title
	 */
	getTitle(): string {
		if (this.NhaCungCap.Id_NCC == 0) {
			return 'THÊM MỚI NHÀ CUNG CẤP';
		}
		return `CHỈNH SỬA NHÀ CUNG CẤP`;
	}
	/**
	 * Check control is invalid
	 * @param controlName: string
	 */
	isControlInvalid(controlName: string): boolean {
		const control = this.NhaCungCapForm.controls[controlName];
		const result = control.invalid && control.touched;
		return result;
	}
	/**
	 * Save data
	 *
	 * @param withBack: boolean
	 */
	onSubmit(status: number) {
		;
		this.hasFormErrors = false;
		const controls = this.NhaCungCapForm.controls;
		/** check form */
		if (this.NhaCungCapForm.invalid) {
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);
			this.hasFormErrors = true;
			return;
		}
		// tslint:disable-next-line:prefer-const
		let editedNhaCungCap = this.prepareNhaCungCaps();
		if(!editedNhaCungCap)	return;
		if (this.NhaCungCap.Id_NCC > 0) {
			this.updateNhaCungCap(editedNhaCungCap,status)
			return;
		}
		this.addNhaCungCap(editedNhaCungCap, status);
	}
	/**
	 * Returns object for saving
	 */
	prepareNhaCungCaps(): NhaCungCapModel {
		const controls = this.NhaCungCapForm.controls;
		if(controls['soNgayThanhToan'].value && +controls['soNgayThanhToan'].value == 0){
			this.layoutUtilsService.showErorr('Số ngày thanh toán nếu nhập thì phải > 0');
			return null;
		}
		const _NhaCungCap = new NhaCungCapModel();
		_NhaCungCap.clear();
		_NhaCungCap.Id_LoaiNCC = controls['Id_LoaiNCC'].value;
		_NhaCungCap.Id_Tinh = controls['Id_Tinh'].value;
		_NhaCungCap.nhomncc = controls['Id_NCC'].value;
		_NhaCungCap.MaNCC = controls['maNCC'].value;
		_NhaCungCap.TenNCC = controls['tenNCC'].value;
		_NhaCungCap.DienThoai = controls['dienThoai'].value;
		_NhaCungCap.DiaChi = controls['diaChi'].value;
		_NhaCungCap.Fax = controls['fax'].value;
		_NhaCungCap.MST = controls['mST'].value;
		_NhaCungCap.SoTK1 = controls['soTK1'].value;
		_NhaCungCap.NganHang1 = controls['nganHang1'].value;
		_NhaCungCap.SoTK2 = controls['soTK2'].value;
		_NhaCungCap.NganHang2 = controls['nganHang2'].value;
		_NhaCungCap.Email = controls['email'].value;
		_NhaCungCap.NguoiLienHe = controls['nguoiLienHe'].value;
		_NhaCungCap.SoDT_NguoiLienHe = controls['soDTNguoiLienHe'].value;
		_NhaCungCap.GhiChu = controls['ghiChu'].value;
		_NhaCungCap.XepLoai = controls['xepLoai'].value;
		_NhaCungCap.SoNgayThanhToan = controls['soNgayThanhToan'].value;
		_NhaCungCap.LoaiHinhKD = controls['LoaiHinhKD'].value;
		_NhaCungCap.DieuKienThanhToan = controls['DieuKienThanhToan'].value;
		
		if (this.NhaCungCap.Id_NCC > 0) {
			_NhaCungCap.Id_NCC = this.NhaCungCap.Id_NCC;
		}
		return _NhaCungCap;
	}
	addNhaCungCap(_NhaCungCap: NhaCungCapModel, status: number) {
		this.nhacungcapsService.createNhaCungCap(_NhaCungCap).subscribe(res => {
			if (res.status == 1) {
				this.isChange = true;
				const message = `Nhà cung cấp mới đã được thêm.`;
				this.layoutUtilsService.showInfo(message);
				if (status == 1) {
					this.back();
				} else if (status == 2) {
					this.NhaCungCap = new NhaCungCapModel();
						this.NhaCungCap.clear();
						this.NhaCungCap.Id_NCC = 0;
					this.NhaCungCapForm.reset();
					this.dungChungService.getBillNumber(this.category_path).subscribe(res => {
						if (res.status == 1 && res.data) {
							this.NhaCungCap.MaNCC = res.data;
							this.createForm();
							this.changeDetectView();
						}
					})
				}
			}
			else {
				this.layoutUtilsService.showErorr(res.error.message);
			}
		});
	}
	updateNhaCungCap(_NhaCungCap: NhaCungCapModel, status: number) {
		this.nhacungcapsService.updateNhaCungCap(_NhaCungCap).subscribe(res => {
			if (res.status == 1) {
				this.isChange = true;
				const message = `Nhà cung cấp đã được cập nhật`;
				this.layoutUtilsService.showInfo(message);
				this.NhaCungCap = new NhaCungCapModel();
				this.NhaCungCap.clear();
				if (status == 1) {
					this.back();
				} else if (status == 2) {
					this.NhaCungCap = new NhaCungCapModel();
					this.NhaCungCap.clear();
					this.NhaCungCap.Id_NCC = 0;
					this.NhaCungCapForm.reset();
					this.dungChungService.getBillNumber(this.category_path).subscribe(res => {
						if (res.status == 1 && res.data) {
							this.NhaCungCap.MaNCC = res.data;
							this.createForm();
						this.changeDetectView();
						}
					})
				}
			}
			else {
				this.layoutUtilsService.showErorr(res.error.message);
			}
		});
	}
	onAlertClose($event) {
		this.hasFormErrors = false;
	}
	numberOnly(event): boolean {
		const charCode = (event.which) ? event.which : event.keyCode;
		if (charCode > 31 && (charCode < 48 || charCode > 57)) {
			return false;
		}
		return true;
	}
	closeDialog() {
		this.dialogRef.close(this.isChange);
	}
	ListId_LoaiNCC() {
		var controls = this.NhaCungCapForm.controls;
		this.nhacungcapsService.listId_LoaiNCC().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listId_LoaiNCC = res.data;
				if(res.data){
					this.selectedId_LoaiNCC=''+this.listId_LoaiNCC[0].Id_LoaiNCC;
					this.createForm();
				}
				// console.log("this.listId_LoaiNCC", this.listId_LoaiNCC);
				this.filteredId_LoaiNCC.next(this.listId_LoaiNCC.slice());
				this.changeDetectorRefs.detectChanges();
			};
		});
	}
	ListId_Tinh() {
		this.nhacungcapsService.listId_Tinh().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listId_Tinh = res.data;
				// console.log("this.listId_Tinh", this.listId_Tinh);
				this.filteredId_Tinh.next(this.listId_Tinh.slice());
				this.changeDetectorRefs.detectChanges();
			};
		});
	}
	ListNhomNCC() {
		var controls = this.NhaCungCapForm.controls;
		this.listId_NhomNCC = this.optionNhomNCC.map(x => Object.assign(x));
		if(this.listId_NhomNCC){
			// this.selectedId_NhomNCC=''+this.listId_NhomNCC[0].value;
			this.createForm();
		}
		// console.log("this.listId_NhomNCC", this.listId_NhomNCC);
		this.filteredId_NhomNCC.next(this.listId_NhomNCC.slice());
		this.changeDetectorRefs.detectChanges();
	}
	filterId_NhomNCC() {
		if (!this.listId_NhomNCC) {
			return;
		}
		// get the search keyword
		let search = this.Id_NhomNCCFilterCtrl;
		if (!search) {
			this.filteredId_NhomNCC.next(this.listId_NhomNCC.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredId_NhomNCC.next(
			this.listId_NhomNCC.filter(ts =>
				(ts.name).toLowerCase().indexOf(search) > -1)
		);
		this.changeDetectView();
	}
	filterId_Tinh() {
		if (!this.listId_Tinh) {
			return;
		}
		// get the search keyword
		let search = this.Id_TinhFilterCtrl;
		if (!search) {
			this.filteredId_Tinh.next(this.listId_Tinh.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredId_Tinh.next(
			this.listId_Tinh.filter(ts =>
				(ts.TenTinh).toLowerCase().indexOf(search) > -1)
		);
		this.changeDetectView();
	}
	filterId_LoaiNCC() {
		if (!this.listId_LoaiNCC) {
			return;
		}
		// get the search keyword
		let search = this.Id_LoaiNCCFilterCtrl;
		if (!search) {
			this.filteredId_LoaiNCC.next(this.listId_LoaiNCC.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredId_LoaiNCC.next(
			this.listId_LoaiNCC.filter(ts =>
				(ts.TenLoaiNCC).toLowerCase().indexOf(search) > -1)
		);
		this.changeDetectView();
	}
	changeDetectView() {
		if (!(this.changeDetectorRefs as ViewRef).destroyed) {
			this.changeDetectorRefs.detectChanges()
		}
	}
	ValidateChangeNumberEvent(event: any) {
		var count = 0;
		for (let i = 0; i < event.target.value.length; i++) {
			if (event.target.value[i] == '.') {
				count += 1;
			}
		}
		var regex = /[a-zA-Z -!$%^&*()_+|~=`{}[:;<>?@#\]]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			const message = 'Dữ liệu không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Dữ liệu không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}
	formatNumber(item: string) {
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-' + this.fixedPoint).toFixed(this.fixedPoint)
	}
	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0, value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1), (this.fixedPoint + 1));
	}
	changeValueOfForm(controlName: string, event: any) {
		if (this.ValidateChangeNumberEvent(event)) {
			let tmpValue = this.NhaCungCapForm.controls[controlName].value.replace(/,/g, "");
			this.NhaCungCapForm.controls[controlName].setValue(this.f_currency(this.formatNumber(tmpValue)));
		}
	}
	ValidateEmailEvent(newValue) {
		const validEmailRegEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		if (validEmailRegEx.test(newValue)) {
			this.validEmail = true;
		} else {
			this.validEmail = false;
		}
		if (newValue == '') {
			this.validEmail = true;
		}
	}
	showCachTaoMa() {
		const _description: string = 'Đây là cách tạo mã cho nhà cung cấp';
		this.layoutUtilsService.showInfo(_description);
	}
	/*Đóng dialog và cập nhập lại tình trạng, trả về highlight ID nếu có*/
	back() {
		this.dialogRef.close(
			{
				IsChange: this.isChange,
			});
	}
}
